const getCardImage = (highlight = {}) => {
    const {image, highlightImage} = highlight;
    const img = highlightImage || image;

    return img || undefined;
};

export {getCardImage};
